export const Config = {
  backendUrl: window._env_.VUE_APP_BACKEND_URL || window.location.protocol + '//' + window.location.host + '/backend-iot-access-control/',
  parentAppName: window._env_.VUE_APP_PARENT_APP_NAME || 'WiCloudS',
  version: '2024.05.07'
};
